import { useMenuFrvtUpdate } from 'api/common/search-fetch'
import { Heading, IconButton, ImageSlider, InfoList, ListTitle, SelectOption, StateDot, Tag } from 'components'
import useModal from 'hook/useModal'
import { mapValues } from 'lodash'
import { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil'
import { userInfoState } from 'store/atom/user-state-atom'
import { isEmptyString } from 'utils/common-util'
import { getMessage } from 'utils/message-util'

// css
import 'assets/style/common.scss'

const ItemList = ({ list = [], recipType = 'STD', isVisible = true }) => {
  return (
    <ul>
      {list.map((item, index) => {
        const irdsRto = Math.round(item.irdsRto || 0)

        const tags = [
          { text: item.gdNo, color: 'gray' },
          { text: item.oriplc, color: 'gray' },
          {
            text: irdsRto
              ? `${item.irdsRto > 0 ? '▲' : '▼'} ${(item.irdsRto > 0 ? irdsRto : irdsRto * -1) + ' %'}`
              : null,
            color: item.irdsRto === null ? 'black-line' : item.irdsRto > 0 ? 'red' : 'blue',
          },
        ]
        return (
          <li className="mt8 border-radius-2 p12 bg-f" key={`recip3_${index}`}>
            <Tag data={tags.filter(({ text }) => text)} />
            <div className="mt8">
              <StateDot color={item.gdUsSttsCd === '0' ? 'success' : item.gdUsSttsCd === '2' ? 'warning' : 'error'} />
              <span className="ml-4 f-14 c-3 f-500">{item.gdBd}</span>
            </div>
            <InfoList
              level="2"
              className="mt12 gap-30"
              dataAlign="right"
              titleWidth={'45px'}
              data={
                recipType === 'STD' || isVisible
                  ? [
                      { id: 1, title: '1인량', data: (item.igrQty || 0).toLocaleString() + ' g' },
                      { id: 2, title: '1인원가', data: (item.trfUnprc || 0).toLocaleString() + ' 원' },
                    ]
                  : [{ id: 1, title: '1인량', data: (item.igrQty || 0).toLocaleString() + ' g' }]
              }
            />
            <InfoList
              level="4"
              className="mt4"
              dataAlign="left"
              titleWidth={'45px'}
              spanMargin={'6px'}
              data={[
                { id: 1, title: '해동', data: item.dfrtNeedYn },
                { id: 2, title: '소독', data: item.dsiftNeedYn },
                { id: 3, title: '중심온도', data: item.cntrTptCnfrmNeedYn },
                { id: 4, title: '원산지', data: item.oriplcYn },
              ]}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default function MenuRecipSite({
  dataList = [],
  imgList = [],
  siteRecipCombo = [],
  onChange = () => {},
  recipType = 'STD',
}) {
  const userInfo = useRecoilValue(userInfoState)
  const ulstyle = { gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr', boxShadow: 'none' }
  const { alertModal, openImageRegist } = useModal()
  const [selected, setSelected] = useState('')
  const [menuId, setMenuId] = useState()
  const [menuSeq, setMenuSeq] = useState('0')
  const [siteId, setSiteId] = useState()
  const [menuType, setMenuType] = useState('')
  const [isFvrt, setIsFvrt] = useState(false)
  const [totalNutt, setTotalNutt] = useState({})
  const [isSteMenu, setIsSteMenu] = useState(false)
  const [seqImages, setSeqImages] = useState([])
  const [isVisible, setIsVisible] = useState(true)

  const menuFrvtUpdate = useMenuFrvtUpdate({
    successHandler: (res, data) => {
      if (data.useYn === 'Y') {
        alertModal(res === 1 ? getMessage('common_msg_006') : getMessage('common_msg_007'))
        setIsFvrt(true)
      } else {
        setIsFvrt(false)
      }
    },
    errorHandler: () => {},
  })

  const changeSteMenu = (menuIdSeq) => {
    if (menuIdSeq) {
      setSelected(menuIdSeq)
      const temp = menuIdSeq.split('|')
      if (temp[3] === 'M') {
        setIsSteMenu(true)
      } else {
        setIsSteMenu(false)
      }
      setMenuId(temp[0])
      setMenuSeq(temp[1])
      setSiteId(temp[2])

      if (temp[1] === '0') {
        setMenuType('표')
      } else if (isEmptyString(temp[4])) {
        setMenuType(`${!isNaN(temp[1]) && Number(temp[1]) > 30000 ? 'A_사' : '사'}`)
      } else {
        setMenuType(`${!isNaN(temp[1]) && Number(temp[1]) > 30000 ? 'A_타' : '타'}`)
      }
    }
  }

  useEffect(() => {
    const phbtUseSiteYn = userInfo.phbtUseSiteList?.includes(siteId) ?? false
    if (
      phbtUseSiteYn !== true ||
      (userInfo.phbtUseUser === true && phbtUseSiteYn === true && siteId?.substring(0, 3) === userInfo.phbtUseUserShpt)
    )
      setIsVisible(true)
    else setIsVisible(false)
  }, [siteId, userInfo.phbtUseUser, userInfo.phbtUseSiteList, userInfo.phbtUseUserShpt])

  useEffect(() => {
    if (siteRecipCombo && siteRecipCombo.length > 0 && selected === '') {
      changeSteMenu(siteRecipCombo[0].menuIdSeq)
    }
  }, [siteRecipCombo])

  useEffect(() => {
    if (dataList.length > 0) {
      let result = {}
      dataList.map((item) => {
        for (const key in item) {
          if (
            key === 'caloQty' ||
            key === 'carbohydrateQty' ||
            key === 'fatQty' ||
            key === 's㎍rQty' ||
            key === 'celluloseQty' ||
            key === 'protQty' ||
            key === 'sfatQty' ||
            key === 'transfatQty' ||
            key === 'cholesterolQty' ||
            key === 'natriumQty' ||
            key === 'calcmQty' ||
            key === 'ironQty' ||
            key === 'vitaminaQty' ||
            key === 'vitamindQty' ||
            key === 'vitamineQty' ||
            key === 'vitaminkQty' ||
            key === 'vitaminb12Qty' ||
            key === 'itamincQty' ||
            key === 'vitaminb1Qty' ||
            key === 'vitaminb2Qty' ||
            key === 'vitaminb6Qty' ||
            key === 'niacinQty' ||
            key === 'folicacidQty' ||
            key === 'pantothenQty' ||
            key === 'biotinQty' ||
            key === 'phosphorusQty' ||
            key === 'potassiumQty' ||
            key === 'chlorineQty' ||
            key === 'magnesiumQty' ||
            key === 'zincQty' ||
            key === 'coppQty' ||
            key === 'manganQty' ||
            key === 'seleniumQty' ||
            key === 'iodineQty' ||
            key === 'ashcontentQty'
          ) {
            result[key] = (result[key] || 0) + item[key]
          }
        }
        return null
      })
      const roundedSums = mapValues(result, (sum) => Math.round(sum * 100) / 100)
      setTotalNutt(roundedSums)
      setIsFvrt(dataList[0].menuBookmarkYn === 'Y')
    }
  }, [dataList])

  const openAddImage = () => {
    const img = imgList.find((img) => img.menuSeq !== 0 && img.menuSeq === parseInt(menuSeq) && img.siteId === siteId)
    const options = {
      menuIdSeq: selected,
    }

    if (img) options.attchFileSerno = img.imgSeq

    openImageRegist(options)
  }

  useEffect(() => {
    const lists = imgList || []

    if (!Array.isArray(lists) || lists.length === 0) return

    if (menuSeq === '0') setSeqImages([])
    else {
      const filteredImg = lists.filter(
        (item) => item.menuId === menuId && item.siteId === siteId && item.menuSeq === parseInt(menuSeq),
      )
      setSeqImages(filteredImg)
    }
  }, [menuSeq])

  return (
    <>
      {/* todo: -아래- 이미지 경로 확인, 이미지 사이즈:280*210(스와이프) */}
      {siteRecipCombo && siteRecipCombo.length > 0 ? (
        <>
          {menuType !== '타' && (
            <div className="fixed-star-btn" style={{ zIndex: 5200, marginBottom: '120px' }}>
              <IconButton
                text="즐겨찾기"
                size="48"
                className={`star bookmark ${isFvrt && 'active'}`}
                onClick={() => {
                  menuFrvtUpdate.mutate({
                    coId: userInfo.coId,
                    regSteId: userInfo.siteId,
                    sessUserId: userInfo.userId,
                    userId: userInfo.userId,
                    myMenuDvsnCd: '1',
                    orgtSteId: siteId,
                    useYn: !isFvrt ? 'Y' : 'N',
                    menuId: menuId,
                    menuSeq: menuSeq,
                    myMenuDvsnCd: '1',
                  })
                }}
              />
            </div>
          )}
          <section className="wrapper mt24">
            <Tag data={[{ text: dataList[0]?.siteNm, color: 'green' }]} />
            <div className="mt4 mb18 flex-between">
              <span className="custom-badge-01" style={{ width: '40px', height: '35px', marginRight: '5px' }}>
                {menuType}
              </span>
              <SelectOption
                value={selected}
                list={siteRecipCombo}
                textKey={'menuNm'}
                valueKey={'menuIdSeq'}
                onChange={(e) => {
                  changeSteMenu(e.target.value)
                  onChange(e)
                }}
              />
              {/* <Heading className="f-20 f-500">{dataList[0].menuNm}</Heading> */}
              {/* <Button text="변경" color="outline-gray" className="small" /> */}
            </div>
          </section>
          <ImageSlider
            addButton={isSteMenu}
            addButtonClick={openAddImage}
            data={seqImages?.map((img) => {
              img.src =
                img.uriType === '9'
                  ? `${process.env.REACT_APP_MENU_FRESH_MEAL_IMAGE_URL}${
                      img.imgUrl.replace(
                        /https:\/\/cjfw-prd-nb-fsapp-s3\.s3\.ap-northeast-2\.amazonaws\.com|https:\/\/fsmealimageprd\.ifresh\.co\.kr/g,
                        '',
                      ) +
                      '?RS=384x288&cTTL=' +
                      process.env.REACT_APP_MENU_IMAGE_CTTL
                    } `
                  : `${process.env.REACT_APP_MENU_IMAGE_URL}/${
                      img.imgUrl + '?RS=384x288&cTTL=' + process.env.REACT_APP_MENU_IMAGE_CTTL
                    } `
              //process.env.REACT_APP_MENU_IMAGE_URL + '/' + img.imgUrl
              img.cTTL = true
              return img
            })}
          />
          <section className="wrapper pb24 mt16">
            <ul className="icon-info-list">
              {(recipType === 'STD' || isVisible) && (
                <li>
                  <span className="label icon-info-1">점포가</span>
                  <span className="data">
                    <b>{(dataList[0]?.totTrfUnprc || 0).toLocaleString()}</b> 원
                  </span>
                </li>
              )}
              <li>
                <span className="label icon-info-2">메모</span>
                <span className="data">
                  {dataList[0]?.chngRsn}
                  {/* 입력된 메모내용 표시
                  <br />
                  (최대 2줄까지 표시) */}
                </span>
              </li>
            </ul>
          </section>

          <section className="wrapper-gray pt24 pb32">
            <ListTitle title="식재정보" count={dataList.length || 0} />
            <Heading level="4" className="mt8 f-noto f-14 c-3 f-normal" text="주재료/재료/고명" />
            <ItemList
              list={dataList?.filter((item) => ['A', 'B', 'H'].indexOf(item.igrMtrlCd) > -1)}
              recipType={recipType}
              isVisible={isVisible}
            />

            <Heading level="4" className="f-noto mt16 f-14 c-3 f-normal" text="주양념/양념" />
            <ItemList
              list={dataList?.filter((item) => ['C', 'D', 'F'].indexOf(item.igrMtrlCd) > -1)}
              recipType={recipType}
              isVisible={isVisible}
            />

            <Heading level="4" className="f-noto mt16 f-14 c-3 f-normal" text="식수/육수" />
            <ItemList
              list={dataList?.filter((item) => ['E', 'G'].indexOf(item.igrMtrlCd) > -1)}
              recipType={recipType}
              isVisible={isVisible}
            />
          </section>
          <section className="wrapper mt24">
            <Heading level="2" text="영양소 정보" className="f-16" />
            <ul className="nutrient-list mt8" style={ulstyle}>
              <li>
                <span className="label">열량</span>
                <span className="data">
                  <b>{typeof totalNutt.caloQty !== 'number' ? '-' : totalNutt.caloQty}</b> kcal
                </span>
              </li>
              <li>
                <span className="label">탄수화물</span>
                <span className="data">
                  <b>{typeof totalNutt.carbohydrateQty !== 'number' ? '-' : totalNutt.carbohydrateQty}</b> g
                </span>
              </li>
              <li>
                <span className="label">단백질</span>
                <span className="data">
                  <b>{typeof totalNutt.protQty !== 'number' ? '-' : totalNutt.protQty}</b> g
                </span>
              </li>
              <li>
                <span className="label">지방</span>
                <span className="data">
                  <b>{typeof totalNutt.fatQty !== 'number' ? '-' : totalNutt.fatQty}</b> g
                </span>
              </li>
              <li>
                <span className="label">나트륨</span>
                <span className="data">
                  <b>{typeof totalNutt.natriumQty !== 'number' ? '-' : totalNutt.natriumQty}</b> mg
                </span>
              </li>
            </ul>
            {/* <ul className="nutrient-list mt4" style={ulstyle}>
              <li>
                <span className="label">콜레스테롤</span>
                <span className="data">
                  <b>{typeof totalNutt.cholesterolQty !== 'number' ? '-' : totalNutt.cholesterolQty}</b> mg
                </span>
              </li>
              <li>
                <span className="label">나트륨</span>
                <span className="data">
                  <b>{typeof totalNutt.natriumQty !== 'number' ? '-' : totalNutt.natriumQty}</b> mg
                </span>
              </li>
              <li>
                <span className="label">당류</span>
                <span className="data">
                  <b>{typeof totalNutt.sugrQty !== 'number' ? '-' : totalNutt.sugrQty}</b> g
                </span>
              </li>
              <li>
                <span className="label">식이섬유</span>
                <span className="data">
                  <b>{typeof totalNutt.celluloseQty !== 'number' ? '-' : totalNutt.celluloseQty}</b> g
                </span>
              </li>
            </ul>
            <ul className="nutrient-list mt4" style={ulstyle}>
              <li>
                <span className="label">포화지방</span>
                <span className="data">
                  <b>{typeof totalNutt.sfatQty !== 'number' ? '-' : totalNutt.sfatQty}</b> g
                </span>
              </li>
              <li>
                <span className="label">트랜스지방</span>
                <span className="data">
                  <b>{typeof totalNutt.transfatQty !== 'number' ? '-' : totalNutt.transfatQty}</b> g
                </span>
              </li>
              <li>
                <span className="label">칼슘</span>
                <span className="data">
                  <b>{typeof totalNutt.calcmQty !== 'number' ? '-' : totalNutt.calcmQty}</b>mg
                </span>
              </li>
              <li>
                <span className="label">철</span>
                <span className="data">
                  <b>{typeof totalNutt.ironQty !== 'number' ? '-' : totalNutt.ironQty}</b> mg
                </span>
              </li>
            </ul>
            <ul className="nutrient-list mt4" style={ulstyle}>
              <li>
                <span className="label">비타민A</span>
                <span className="data">
                  <b>{typeof totalNutt.vitaminaQty !== 'number' ? '-' : totalNutt.vitaminaQty}</b> RE
                </span>
              </li>
              <li>
                <span className="label">비타민D</span>
                <span className="data">
                  <b>{typeof totalNutt.vitamindQty !== 'number' ? '-' : totalNutt.vitamindQty}</b> ㎍
                </span>
              </li>
              <li>
                <span className="label">비타민E</span>
                <span className="data">
                  <b>{typeof totalNutt.vitamineQty !== 'number' ? '-' : totalNutt.vitamineQty}</b> mg
                </span>
              </li>
              <li>
                <span className="label">비타민K</span>
                <span className="data">
                  <b>{typeof totalNutt.vitaminkQty !== 'number' ? '-' : totalNutt.vitaminkQty}</b> ㎍
                </span>
              </li>
            </ul>
            <ul className="nutrient-list mt4" style={ulstyle}>
              <li>
                <span className="label">비타민B12</span>
                <span className="data">
                  <b>{typeof totalNutt.vitaminb12Qty !== 'number' ? '-' : totalNutt.vitaminb12Qty}</b> ㎍
                </span>
              </li>
              <li>
                <span className="label">비타민C</span>
                <span className="data">
                  <b>{typeof totalNutt.vitamincQty !== 'number' ? '-' : totalNutt.vitamincQty}</b> mg
                </span>
              </li>
              <li>
                <span className="label">비타민B1</span>
                <span className="data">
                  <b>{typeof totalNutt.vitaminb1Qty !== 'number' ? '-' : totalNutt.vitaminb1Qty}</b> mg
                </span>
              </li>
              <li>
                <span className="label">비타민B2</span>
                <span className="data">
                  <b>{typeof totalNutt.vitaminb2Qty !== 'number' ? '-' : totalNutt.vitaminb2Qty}</b> mg
                </span>
              </li>
            </ul>
            <ul className="nutrient-list mt4" style={ulstyle}>
              <li>
                <span className="label">비타민B6</span>
                <span className="data">
                  <b>{typeof totalNutt.vitaminb12Qty !== 'number' ? '-' : totalNutt.vitaminb12Qty}</b> mg
                </span>
              </li>
              <li>
                <span className="label">니아신</span>
                <span className="data">
                  <b>{typeof totalNutt.niacinQty !== 'number' ? '-' : totalNutt.niacinQty}</b> mg
                </span>
              </li>
              <li>
                <span className="label">엽산</span>
                <span className="data">
                  <b>{typeof totalNutt.folicacidQty !== 'number' ? '-' : totalNutt.folicacidQty}</b> ㎍
                </span>
              </li>
              <li>
                <span className="label">판토텐신</span>
                <span className="data">
                  <b>{typeof totalNutt.pantothenQty !== 'number' ? '-' : totalNutt.pantothenQty}</b> mg
                </span>
              </li>
            </ul>
            <ul className="nutrient-list mt4" style={ulstyle}>
              <li>
                <span className="label">비오틴</span>
                <span className="data">
                  <b>{typeof totalNutt.biotinQty !== 'number' ? '-' : totalNutt.biotinQty}</b> ㎍
                </span>
              </li>
              <li>
                <span className="label">인</span>
                <span className="data">
                  <b>{typeof totalNutt.phosphorusQty !== 'number' ? '-' : totalNutt.phosphorusQty}</b> mg
                </span>
              </li>
              <li>
                <span className="label">칼륨</span>
                <span className="data">
                  <b>{typeof totalNutt.potassiumQty !== 'number' ? '-' : totalNutt.potassiumQty}</b> mg
                </span>
              </li>
              <li>
                <span className="label">염소</span>
                <span className="data">
                  <b>{typeof totalNutt.chlorineQty !== 'number' ? '-' : totalNutt.chlorineQty}</b> mg
                </span>
              </li>
            </ul>
            <ul className="nutrient-list mt4" style={ulstyle}>
              <li>
                <span className="label">마그네슘</span>
                <span className="data">
                  <b>{typeof totalNutt.magnesiumQty !== 'number' ? '-' : totalNutt.magnesiumQty}</b> mg
                </span>
              </li>
              <li>
                <span className="label">아연</span>
                <span className="data">
                  <b>{typeof totalNutt.zincQty !== 'number' ? '-' : totalNutt.zincQty}</b> mg
                </span>
              </li>
              <li>
                <span className="label">구리</span>
                <span className="data">
                  <b>{typeof totalNutt.coppQty !== 'number' ? '-' : totalNutt.coppQty}</b> mg
                </span>
              </li>
              <li>
                <span className="label">망간</span>
                <span className="data">
                  <b>{typeof totalNutt.manganQty !== 'number' ? '-' : totalNutt.manganQty}</b> mg
                </span>
              </li>
            </ul>
            <ul className="nutrient-list mt4" style={ulstyle}>
              <li>
                <span className="label">셀레늄</span>
                <span className="data">
                  <b>{typeof totalNutt.seleniumQty !== 'number' ? '-' : totalNutt.seleniumQty}</b> ㎍
                </span>
              </li>
              <li>
                <span className="label">요오드</span>
                <span className="data">
                  <b>{typeof totalNutt.iodineQty !== 'number' ? '-' : totalNutt.iodineQty}</b> ㎍
                </span>
              </li>
              <li>
                <span className="label">화분</span>
                <span className="data">
                  <b>{typeof totalNutt.ashcontentQty !== 'number' ? '-' : totalNutt.ashcontentQty}</b> g
                </span>
              </li>
              <li></li>
            </ul> */}
          </section>
        </>
      ) : (
        siteRecipCombo &&
        siteRecipCombo.length === 0 && (
          <div className="flex-1 flex-align-center" style={{ marginTop: '40px' }}>
            <div className="flex-col flex-item-center">
              <span className="icon-message-gray"></span>
              <p style={{ marginTop: '20px' }}>등록된 사이트레시피가 없습니다.</p>
              <p style={{ width: '80%' }}>
                해당 레시피를 이용하고자 하실 경우 PC화면에서 사이트레시피로 등록 후 이용할 수 있습니다.
              </p>
            </div>
          </div>
        )
      )}
    </>
  )
}
